import { t } from 'i18next'
import { Tag } from 'primereact/tag'

import { HistoryStatusType } from '../../../data/model'

export const statusBodyTemplate = (status?: HistoryStatusType) => {
  if (!status) return null

  const getTranslation = (status: HistoryStatusType) =>
    STATUS_TRANSLATIONS[status] || ''

  const STATUS_TRANSLATIONS: Record<HistoryStatusType, string> = {
    Accepted: t(
      'deliveryForecastsHistory.table.columns.status.options.accepted',
    ),
    AcceptedWithChanges: t(
      'deliveryForecastsHistory.table.columns.status.options.acceptedwithchanges',
    ),
    Changed: t('deliveryForecastsHistory.table.columns.status.options.changed'),
    Completed: t(
      'deliveryForecastsHistory.table.columns.status.options.completed',
    ),
    InProgress: t(
      'deliveryForecastsHistory.table.columns.status.options.inprogress',
    ),
    Initial: t('deliveryForecastsHistory.table.columns.status.options.initial'),
    Open: t('deliveryForecastsHistory.table.columns.status.options.open'),
    Rejected: t(
      'deliveryForecastsHistory.table.columns.status.options.rejected',
    ),
    Replaced: t(
      'deliveryForecastsHistory.table.columns.status.options.replaced',
    ),
  }

  const getColor = (status: HistoryStatusType) => STATUS_COLORS[status] || ''

  const STATUS_COLORS: Record<HistoryStatusType, string> = {
    Accepted: 'bg-green-200 text-green-900',
    AcceptedWithChanges: 'bg-orange-200 text-orange-900',
    Changed: 'bg-orange-200 text-orange-900',
    Completed: 'bg-green-200 text-green-900',
    InProgress: 'bg-blue-200 text-blue-900',
    Initial: 'bg-cyan-200 text-cyan-900',
    Open: 'bg-blue-200 text-blue-900',
    Rejected: 'bg-red-200 text-red-900',
    Replaced: 'bg-orange-200 text-orange-900',
  }

  return <Tag value={getTranslation(status)} className={getColor(status)}></Tag>
}
